
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxes",
      function () {
        return require("private-next-pages/taxes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxes"])
      });
    }
  